import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleBookingSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle cx={28} cy={28} fill="#56a" opacity={0.88} r={28} />
        <path
          d="M35.51 16.96h-3.85A3.91 3.91 0 0027.58 13c-2.67 0-4.28 2.01-4.28 3.96h-3.66A2.65 2.65 0 0017 19.6v16.76A2.65 2.65 0 0019.64 39h15.87a2.65 2.65 0 002.65-2.64V19.6a2.65 2.65 0 00-2.65-2.64zm-6.7 15.12c0 .24-.17.43-.4.43h-7.2c-.21 0-.4-.2-.4-.43v-.85c0-.23.19-.42.4-.42h7.2c.23 0 .4.19.4.42zm5.53-4.5c0 .24-.3.43-.68.43H21.5c-.37 0-.67-.2-.67-.43v-.85c0-.23.3-.42.67-.42h12.17c.37 0 .68.19.68.42v.85zm0-4.5c0 .24-.3.43-.68.43H21.5c-.37 0-.67-.2-.67-.43v-.85c0-.23.3-.42.67-.42h12.17c.37 0 .68.19.68.42v.85zm-6.76-7.44a1.32 1.32 0 110 2.64 1.32 1.32 0 110-2.64z"
          fill="#fff"
        />
        <circle cx={38} cy={36} fill="#8f9dd6" r={9} />
        <path
          d="M38 31.42l1.65 2.89 3.35.62-2.33 2.4.42 3.27L38 39.2l-3.09 1.4.42-3.27-2.33-2.4 3.35-.63z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

SvgPicCircleBookingSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleBookingSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleBookingSelected svgRef={ref} {...props} />
));
export default ForwardRef;
